module.exports = __webpack_public_path__ + "img/defaultAvatar.94b9c0b0.png";